import { render, staticRenderFns } from "./subAccountManagement.vue?vue&type=template&id=83552ee2&scoped=true&"
import script from "./subAccountManagement.vue?vue&type=script&lang=js&"
export * from "./subAccountManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83552ee2",
  null
  
)

export default component.exports